import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
type Maybe<T> = T | null;
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  unauthorized: Scalars['Boolean'];
  currentUser?: Maybe<CurrentUser>;
  artists: Array<Maybe<Artist>>;
};


type QueryArtistsArgs = {
  ids: Array<Scalars['String']>;
};

type CurrentUser = {
  __typename?: 'CurrentUser';
  hasAccess: Scalars['Boolean'];
  hasLabelOnlyAccess: Scalars['Boolean'];
  imageUrl: Scalars['String'];
  largeImageUrl: Scalars['String'];
  loginEmail: Scalars['String'];
  name: Scalars['String'];
  needsToAcceptTerms: Scalars['Boolean'];
  partnerIds: CurrentUserPartnerIds;
  username: Scalars['String'];
};

type CurrentUserPartnerIds = {
  __typename?: 'CurrentUserPartnerIds';
  google: Scalars['String'];
};

type Artist = {
  __typename?: 'Artist';
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  uri: Scalars['String'];
};

type GetArtistsByUrisQueryVariables = Exact<{
  ids: Array<Scalars['String']>;
}>;


type GetArtistsByUrisQuery = (
  { __typename?: 'Query' }
  & { artists: Array<Maybe<(
    { __typename?: 'Artist' }
    & Pick<Artist, 'id' | 'imageUrl' | 'name' | 'uri'>
  )>> }
);


 const GetArtistsByUrisDocument = gql`
    query GetArtistsByUris($ids: [String!]!) {
  artists(ids: $ids) {
    id
    imageUrl
    name
    uri
  }
}
    `;

type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
 function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetArtistsByUris(variables: GetArtistsByUrisQueryVariables): Promise<GetArtistsByUrisQuery> {
      return withWrapper(() => client.request<GetArtistsByUrisQuery>(print(GetArtistsByUrisDocument), variables));
    }
  };
}
type Sdk = ReturnType<typeof getSdk>;
import {client} from '@mrkt/features/graphql-sdk';
export const sdk = getSdk(client);
